'use strict';

import * as _ from 'lodash';
import moment from 'moment';

const angular = require('angular');
const uiRouter = require('angular-ui-router');
import uiBootstrap from 'angular-ui-bootstrap';

import routes from './support.routes';


export class SupportComponent {
  
}

export default angular.module('syncplicityLoginApp.support', [uiRouter])
  .config(routes)
  .component('support', {
    template: require('./support.html'),
    controller: SupportComponent,
    controllerAs: 'supportCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/support/support.component.js